import React from 'react';
import { Button, Empty, Modal, Typography } from 'antd';
import { RichTextViewer } from '../../components/RichTextEditor';
import { authorName } from './authors';
import { formatLogged } from './entryTable';
import { useGetProgramFeedbackQuery } from '../../redux/api/manufacturing';

const { Text } = Typography;

interface ProgramFeedbackModalProps {
	programId: string | null;
	partName: string;
	open: boolean;
	onClose: () => void;
}

/**
 * All feedback logged against one program, read-only.
 *
 * The scoring grid keeps feedback as a count until the user asks to see it.
 */
const ProgramFeedbackModal: React.FC<ProgramFeedbackModalProps> = ({
	programId,
	partName,
	open,
	onClose,
}) => {
	const { data, isLoading } = useGetProgramFeedbackQuery(
		{ program: programId as string },
		{ skip: !programId || !open }
	);
	const entries = data?.results || [];

	return (
		<Modal
			className="cam-modal"
			title={`Feedback — ${partName}`}
			open={open}
			centered
			onCancel={onClose}
			footer={<Button onClick={onClose}>Close</Button>}
			width={780}
			destroyOnClose
		>
			{isLoading ? (
				<Text type="secondary">Loading feedback…</Text>
			) : entries.length === 0 ? (
				<Empty
					image={Empty.PRESENTED_IMAGE_SIMPLE}
					description="No feedback logged"
				/>
			) : (
				<div className="cam-entry-list">
					{entries.map((entry) => (
						<div key={entry.id} className="cam-entry">
							<div className="cam-entry__header">
								<Text ellipsis style={{ fontSize: 13 }}>
									{authorName(entry.author, 'Unknown')}
								</Text>
								<Text type="secondary" className="cam-thread__time">
									{formatLogged(entry.created_time)}
								</Text>
							</div>
							<RichTextViewer
								html={entry.body}
								emptyText="No content"
								className="cam-entry__body"
							/>
						</div>
					))}
				</div>
			)}
		</Modal>
	);
};

export default ProgramFeedbackModal;
